import { COLORS, Col, FlexView, Row } from '@cuemath/comps';
import React from 'react';
import useLogic from './TeacherRetentionSummary.logic';
import { Separator, Text } from '@cuemath/web-comps';
import styled from 'styled-components';

const Value = styled(Col)`
  padding-left: 6px;
`;

const TeacherRetentionSummary = () => {
  const { retentionSummary } = useLogic();

  return (
    <FlexView>
      <Text variant="eyebrow2" color={COLORS.COLA_LIGHTER}>
        Teacher Retention Summary
      </Text>
      <Separator height={16} />
      {retentionSummary?.map(({ key, label, value, isBold }) => (
        <>
          <Row justifyContent="space-between" key={key} gutter={0} wrap>
            <Col gutter={0} auto>
              <Text variant={isBold ? 'cta2' : 'body2'}>{label}</Text>
            </Col>
            <Value gutter={0}>
              <Text variant="cta2">{value}</Text>
            </Value>
          </Row>
          <Separator height={12} />
        </>
      ))}
    </FlexView>
  );
};
export default TeacherRetentionSummary;
